import { mixins, mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { outsideElementsColumnWidthPx } from './Table.constants';
import { BaseItem, TableProps } from './Table.types';

export const defaultSpacing = '12 8' as const;
export const checkboxSpacing = '4 4' as const;

export const ScrollableContainer = styled.section<
    StyledMods<{ hasRowActionMenu?: boolean; hasReorderableRows?: boolean }>
>`
    width: 100%;
    height: 100%;
    overflow: auto;
    margin-bottom: 2px;

    &::-webkit-scrollbar-track {
        background: ${theme.color.white100};

        &:hover {
            background: ${theme.color.white100};
        }
    }

    &::-webkit-scrollbar-track-piece:start,
    &::-webkit-scrollbar-track-piece:end {
        background: ${theme.color.midnight30};

        &:hover {
            background: ${theme.color.midnight40};
        }
    }

    ${mods('hasReorderableRows', true)`
        width: calc(100% + ${outsideElementsColumnWidthPx}px);
        margin-left: -${outsideElementsColumnWidthPx}px;

        &::-webkit-scrollbar-track-piece:start {
            margin-left: ${outsideElementsColumnWidthPx}px;
        }
    `};

    ${mods('hasRowActionMenu', true)`
        width: calc(100% + ${outsideElementsColumnWidthPx}px);
        margin-right: -${outsideElementsColumnWidthPx}px;

        &::-webkit-scrollbar-track-piece:end {
            margin-right: ${outsideElementsColumnWidthPx}px;
        }
    `};

    ${mods(['hasReorderableRows', 'hasRowActionMenu'], true)`
        width: calc(100% + ${outsideElementsColumnWidthPx * 2}px);
    `};
`;

export const Root = styled.table<
    StyledMods<Pick<TableProps<BaseItem>, 'fontSize' | 'virtualized'>> &
        StyledMods<{ reorderableRows?: boolean; hasRowActionMenu?: boolean }>
>`
    width: 100%;
    border-collapse: collapse;

    ${mods('virtualized', true)`
        margin-left: 0;
    `};

    ${mods.fontSize((value) => mixins.font('body', value))};
`;
